import { Check } from "@mui/icons-material";
import React, {useEffect, useState} from "react";
import { useHistory } from "react-router-dom";

const VariableEntry = (props) => {
    return <div className="variable-entry">
            <div className="variable-header">
                {props.name}
            </div>
            {
                props.variable_history ? 
                    props.variable_history.map(v => {
                        return <div key={v.id} className="variable-value-entry">
                            <div className="variable-value">
                                <div className="variable-value-label">Value</div>
                                <div className="variable-value-value">
                                {v.value}<div className="variable-value-units">{v.unit}</div>
                                </div>
                            </div>
                            <div className=".variable-value-attr">
                                <div className="variable-value-label">Collection Method</div>
                                {v.collection_method}
                            </div>
                            <div className="variable-value-attr">
                                <div className="variable-value-label">Collected By</div>
                                {v.collected_by}
                            </div>
                            <div className="variable-value-attr">
                                <div className="variable-value-label">Collection Date</div>
                                {v.collection_date}
                            </div>
                        </div>
                    }) : 
                    props.inherited_history ?
                        <div key={props.inherited_history.id} className="variable-value-entry">
                                <div className="variable-value">
                                    <div className="variable-value-label">Value</div>
                                    <div className="variable-value-value">
                                    {props.inherited_history.value}<div className="variable-value-units">{props.inherited_history.unit}</div>
                                    </div>
                                </div>
                                <div className="variable-value-attr">
                                    <div className="variable-value-label">Collection Method</div>
                                    {props.inherited_history.collection_method}
                                </div>
                                <div className="variable-value-attr">
                                    <div className="variable-value-label">Collected By</div>
                                    {props.inherited_history.collected_by}
                                </div>
                                <div className="variable-value-attr">
                                    <div className="variable-value-label">Collection Date</div>
                                    {props.inherited_history.collection_date}
                                </div>
                                <div className="variable-value-attr">
                                    <div className="variable-value-label">Inherited From</div>
                                    { props.inherited_history.from}
                                </div>
                            </div>
                    :
                    <div key={props.name} className="variable-value-empty">
                        No values collected.
                    </div>
            }
    </div>
}

export default VariableEntry;